import { render } from "./lyrics.vue?vue&type=template&id=44dc7acf"
import script from "./lyrics.vue?vue&type=script&lang=js"
export * from "./lyrics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__